<template>
    <div v-if="hotel">
        <strong class="d-block">{{ hotel.name }}</strong>
        <strong class="d-block">{{ room.name }}</strong>
        <strong v-if="searchRequest" class="d-block">
            {{ $t('check_in') }} / {{ $t('check_out') }}: {{ $filters.dateFormat(searchRequest.startDate) }} -
            {{ $filters.dateFormat(searchRequest.endDate) }}
        </strong>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {EventBus, HIDE_CONDITIONAL_MODAL_INFO, SHOW_HOTEL_CONDITIONS_INFO} from '@/utils/event-bus'

    @Component
    export class HotelConditionsModalInfo extends Vue {
        searchRequest = null
        hotel = null
        room = null

        mounted() {
            EventBus.$on(SHOW_HOTEL_CONDITIONS_INFO, this.showInfo)
            EventBus.$on(HIDE_CONDITIONAL_MODAL_INFO, this.hideInfo)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_HOTEL_CONDITIONS_INFO, this.showInfo)
            EventBus.$off(HIDE_CONDITIONAL_MODAL_INFO, this.hideInfo)
        }

        showInfo({searchRequest, hotel, room}) {
            this.searchRequest = searchRequest
            this.room = room
            this.hotel = hotel
        }

        hideInfo() {
            this.hotel = null
        }
    }

    export default HotelConditionsModalInfo
</script>
